import React, { FC } from 'react';

import { Box } from '@mui/material';

import {
  ICalendarEventType,
  RecurrenceActions,
  pharmacyWorkshift,
} from '@pharmaplan/common';

import useUpdateSelfShiftFormik from '../../../../hooks/workshift/useUpdateSelfShiftFormik';
import useSyncWorkshiftValues from '../../../../hooks/workshift/useSyncWorkshiftValues';
import { selectFooterPaginationCurrent } from '../../../../selectors/drawerSelector';
import useUpdateWorkshift from '../../../../hooks/workshift/useUpdateWorkshift';
import LongTermHourlyRates from '../AddWorkshift/LongTermHourlyRates';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import CustomTextField from '../../../common/CustomTextField';
import genericClasses from '../../../../theme/GenericClasses';
import { isIpad } from '../../../../helpers/Constants';
import AllowanceWorkshift from '../AllowanceWorkshift';
import strings from '../../../../localization';

import WorkshiftForm from '../WorkshiftForm';
import classes from './styles';

interface IUpdate {
  eventIds: Array<string>;
  recurrenceId?: string;
  recType?: RecurrenceActions;
  type: ICalendarEventType;
}

const { series } = RecurrenceActions;

const Update: FC<IUpdate> = ({ eventIds, recurrenceId, recType, type }) => {
  const current = useAppSelector(selectFooterPaginationCurrent);
  const currentWorkshift = useAppSelector(pharmacyWorkshift);
  const {
    longTermShiftContractId,
    startDate,
    bookedWeekDayCost,
    bookedWeekendCost,
    bookedWeekDayHours,
    bookedWeekendHours,
  } = currentWorkshift ?? {};

  const isLongTerm = !!longTermShiftContractId;

  const id = eventIds[current - 1];

  const isSeries = recType === series;

  const { container } = classes;
  const { borderNoneTextField } = genericClasses;

  const { formik } = useUpdateSelfShiftFormik(id, isSeries, recurrenceId);

  useUpdateWorkshift(eventIds, formik, recurrenceId, recType, type);
  useSyncWorkshiftValues(formik);

  const notesSx = isIpad ? classes.notes : {};

  return (
    <Box sx={container}>
      <WorkshiftForm
        isSeries={isSeries}
        formik={formik}
        openedDate={startDate}
        isUpdate
      />
      {isLongTerm ? (
        <LongTermHourlyRates
          bookedWeekdayCost={bookedWeekDayCost}
          bookedWeekendCost={bookedWeekendCost}
          bookedWeekdayHours={bookedWeekDayHours}
          bookedWeekendHours={bookedWeekendHours}
          formik={formik}
        />
      ) : (
        <AllowanceWorkshift formik={formik} />
      )}

      {isLongTerm && (
        <Box sx={notesSx}>
          <CustomTextField
            variant="outlined"
            formik={formik}
            id="notes"
            placeholder={strings.allowancePlaceholder}
            label={strings.allowances}
            name="allowanceNotes"
            multiline
            maxLength={200}
            customClass={borderNoneTextField}
          />
        </Box>
      )}

      <Box sx={notesSx}>
        <CustomTextField
          variant="outlined"
          formik={formik}
          id="notes"
          placeholder=" "
          label={strings.notes}
          name="notes"
          multiline
          maxLength={200}
          customClass={borderNoneTextField}
        />
      </Box>
    </Box>
  );
};

export default Update;
